import { createReducer, on } from '@ngrx/store';

import { ManageSurveyActions } from '../manage-survey/manage-survey.actions';
import {
  INITIAL_MANAGE_SURVEY_REFERENCE_STATE,
  ManageSurveyReferenceState,
} from './manage-survey-reference.model';
import {
  ManageSurveyReferenceActions,
  ManageSurveyReferenceApiActions,
} from './manage-survey-reference.actions';

export const manageSurveyReferenceReducer = createReducer(
  INITIAL_MANAGE_SURVEY_REFERENCE_STATE,

  on(
    ManageSurveyReferenceActions.loadSupplierAllocations,
    (state): ManageSurveyReferenceState => ({
      ...state,
      supplierAllocationsLoading: true,
      supplierAllocationsError: null,
    }),
  ),

  // Switching to a child survey shows a different survey's allocations, so the
  // previous list is dropped rather than left on screen under the spinner.
  on(
    ManageSurveyActions.loadChildSurveyDetails,
    (): ManageSurveyReferenceState => ({
      supplierAllocations: [],
      supplierAllocationsLoading: true,
      supplierAllocationsError: null,
    }),
  ),

  on(
    ManageSurveyActions.resetSurveyDetails,
    (): ManageSurveyReferenceState => INITIAL_MANAGE_SURVEY_REFERENCE_STATE,
  ),

  on(
    ManageSurveyReferenceApiActions.loadSupplierAllocationsSuccess,
    (state, { supplierAllocations }): ManageSurveyReferenceState => ({
      ...state,
      supplierAllocations,
      supplierAllocationsLoading: false,
      supplierAllocationsError: null,
    }),
  ),

  on(
    ManageSurveyReferenceApiActions.loadSupplierAllocationsFailure,
    (state, { error }): ManageSurveyReferenceState => ({
      ...state,
      supplierAllocations: [],
      supplierAllocationsLoading: false,
      supplierAllocationsError: error,
    }),
  ),
);
